var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#00A1DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.814C23.5 14.6205 23.0259 13.4759 22.182 12.632C21.3381 11.7881 20.1935 11.314 19 11.314C17.8065 11.314 16.6619 11.7881 15.818 12.632C14.9741 13.4759 14.5 14.6205 14.5 15.814C14.5 21.064 12.25 22.564 12.25 22.564H25.75C25.75 22.564 23.5 21.064 23.5 15.814Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2976 25.9387C20.1658 26.166 19.9765 26.3547 19.7488 26.4859C19.5211 26.617 19.2629 26.6861 19.0001 26.6861C18.7374 26.6861 18.4792 26.617 18.2515 26.4859C18.0238 26.3547 17.8345 26.166 17.7026 25.9387",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNBell);
export default __webpack_public_path__ + "static/media/n-bell.9274c55ec7e1043a64b96659b7299156.svg";
export { ForwardRef as ReactComponent };